import React from "react";
import { Navigate, Route, RouteProps, Routes } from "react-router-dom";


// All layouts containers
import DefaultLayout from "../layouts/Default";
import VerticalLayout from "../layouts/Vertical";

import { RoutesProps, authProtectedFlattenRoutes, publicProtectedFlattenRoutes } from ".";
import { FIRM_PATH } from "../constants/storageKeys";
import Error404 from "../features/pages/error/Error404";
import { ResetScrollBar } from "../features/components/ResetScrollBar";

const prefixPath = ":firmname";

const firmPath = localStorage.getItem(FIRM_PATH);
const AllRoutes = (props: RouteProps) => {



  return (
    <React.Fragment>
      <ResetScrollBar/>
      <Routes>
        <Route>
          <Route
            path={"/"}
            element={<Error404 />}
            key={"roott2"}
          />

          <Route
            path={"/" + firmPath}
            element={
              <DefaultLayout passtenantControl={false}
                {...props}
              >

                <Navigate to={"/" + firmPath + '/dashboard'} />
              </DefaultLayout>
            }
            key={"roott"}
          />
          {publicProtectedFlattenRoutes.map((route: RoutesProps, idx: number) => (
            <Route
              path={(route.passsubfolder ? "" : prefixPath) + route.path}
              element={
                <DefaultLayout passtenantControl={route.passTenantControl || false}
                  {...props}
                >

                  {route.element}
                </DefaultLayout>
              }
              key={idx}
            />
          ))}
        </Route>

        <Route>
          {authProtectedFlattenRoutes.map((route: RoutesProps, idx: number) => {
            return (
              <Route
                path={prefixPath + route.path}
                element={
                  <VerticalLayout {...props} routeKey={route.menuKey || ""} >{route.element}</VerticalLayout>
                }
                key={idx}
              />
            )
          })}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default AllRoutes;
